
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission } from '@core/objects/form';
import { WysiwygData } from '@core/models/wysiwyg-data.model';

@Component({
    selector: 'form-field-fill-rich-text-v1',
    templateUrl: './fill-rich-text-v1.component.html'
})
export class FillRichTextV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();

    public placeholder: string = "Type your text here";
    public value: string = "";
    public valid: boolean = false;


    ngOnInit(): void {
        // Set the value only if the provided field value is not an empty string
        if (this.fieldSubmission.serialized_value && this.fieldSubmission.serialized_value.trim() !== '') {
            this.value = this.fieldSubmission.serialized_value;  // Set the value without triggering the input event
            this.valid = this.value.trim() !== ''; // Update validity
        }
        this.emitValidity();
    }

    onTextEditorChange(value: WysiwygData) {
        // prevent emit changes on first load of the form rich text editor
        // for that we use stric compare with normalized html omitting BOM chars
        //  that are being used to encode emojis.
        if ( this.normalizeHtml(this.value) === this.normalizeHtml(value.html)){
            return;
        }
        this.valid = value.text.trim() != '' || !this.fieldSubmission.field.mandatory; 
        // console.log(" Richt TExt value----> ", value, value.text.trim(), this.valid);
        if(this.valid)
            this.fieldValueChange.emit({uuid: this.fieldSubmission.field.uuid, alias: this.fieldSubmission.field.alias, value: value.html});
        this.emitValidity();
    }

    // avoid BOM caracter on check html value to perfect match
    private normalizeHtml(html: string): string {
        return html.replace(/\ufeff/g, "")  // Remove invisible BOM characters
                    .trim();
    }

    private emitValidity(): void {
        this.fieldValidityChange.emit({ id: this.fieldSubmission.field.uuid, valid: this.fieldSubmission.field.mandatory ? this.valid :  true });
    }

}
